import { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import _ from 'lodash';
//components
import FormCreator from 'components/FormCreator';
import { setListOfInvalids } from 'components/FormCreator/validation';
import { fieldsGroupType, fieldType, invalidFields, validationTypes } from 'components/FormCreator/types';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { userFieldsValidations } from 'constants/settings.constants';
import UserEditCard from './UserEditCard';
import { changeUserData } from 'services/user.services';
import { FormInputsTypes } from 'constants/settings.constants';
import { API_UPDATE_CONTACT_NAME } from 'constants/db.constants';
import { validateFields } from 'components/FormCreator/validation';

export default function EditName({ handleCancelEdit, dataToEdit, userDetails }) {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const [disabledSubmit, setDisabledSubmit] = useState(true);
	const language = localStorage.getItem('language');
	const [firstName, setFirstName] = useState(
		language === 'he' ? userDetails?.firstNameHebrew : userDetails?.firstName
	);
	const [lastName, setLastName] = useState(language === 'he' ? userDetails?.lastNameHebrew : userDetails?.lastName);
	const prefixFields = 'page.settings.my_profile.user_details.';

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		updateInput(name, event.target.value);
		if (_.has(userFieldsValidations, name)) {
			setInvalidFields(setListOfInvalids(invalidFields, userFieldsValidations, name, value));
		}
	};

	const updateInput = (name, value) => {
		if (name === 'firstName') {
			setFirstName(value);
		} else {
			setLastName(value);
		}
	};

	const handleSaveClick = () => {
		let obj = {};
		_.keys(userFieldsValidations).forEach((key) => {
			obj = {
				...obj,
				['firstName']: firstName,
				['lastName']: lastName,
				['language']: language,
			};
		});
		const invalidFields = validateFields(userFieldsValidations, obj);
		if (_.keys(invalidFields).length) {
			setInvalidFields(invalidFields);
		} else {
			const formData = new FormData();
			formData.append('firstName', String(firstName));
			formData.append('lastName', String(lastName));
			formData.append('language', String(language));
			dispatch(
				changeUserData(
					{ firstName, lastName, language },
					formData,
					FormInputsTypes.NAME,
					API_UPDATE_CONTACT_NAME
				)
			);
		}
	};

	const [invalidFields, setInvalidFields] = useState<invalidFields>({});

	useEffect(() => {
		if (_.keys(invalidFields).length) {
			setDisabledSubmit(true);
		} else {
			setDisabledSubmit(false);
		}
	}, [firstName, lastName]);

	return (
		<UserEditCard
			handleSaveClick={handleSaveClick}
			handleCancelEdit={handleCancelEdit}
			title={t(prefixFields + 'title')}
			cancelButtonText={t(prefixFields + 'cancel_button.text')}
			saveButtonText={t(prefixFields + 'save_button.text')}
			dataToEdit={dataToEdit}
			disabledSubmit={disabledSubmit}
		>
			<FormCreator
				initialValidation={invalidFields}
				name="contactName"
				handleChange={handleChange}
				fieldsGroups={[
					{
						type: fieldsGroupType.col,
						fields: [
							{
								type: fieldType.text,
								validation: [validationTypes.requierd, validationTypes.englishAndHebrewLettersOnly],
								props: {
									required: true,
									name: 'firstName',
									label: t(`${prefixFields}first_name.text`),
									placeholder: t(`${prefixFields}first_name.placeholder`),
									value: firstName,
								},
							},
							{
								type: fieldType.text,
								validation: [validationTypes.requierd, validationTypes.englishAndHebrewLettersOnly],
								props: {
									required: true,
									name: 'lastName',
									label: t(`${prefixFields}last_name.text`),
									placeholder: t(`${prefixFields}last_name.placeholder`),
									value: lastName,
								},
							},
						],
					},
				]}
			/>
		</UserEditCard>
	);
}
